export const NAV_CELL_SELECTOR = '.nav-cell:not(:disabled)';

/** Next/previous focusable cell in DOM order (rows render top-to-bottom, columns left-to-right,
 *  so DOM order already matches reading order — §1 «Tab и Enter переходят по полям»). */
export function nextNavCell(container: HTMLElement, current: HTMLElement, dir: 1 | -1): HTMLElement | null {
  const cells = Array.from(container.querySelectorAll<HTMLElement>(NAV_CELL_SELECTOR));
  const index = cells.indexOf(current);
  if (index === -1) return null;
  return cells[index + dir] ?? null;
}

export function isLastNavCell(container: HTMLElement, current: HTMLElement): boolean {
  const cells = Array.from(container.querySelectorAll<HTMLElement>(NAV_CELL_SELECTOR));
  return cells.length > 0 && cells[cells.length - 1] === current;
}

const CONTROL = 'input, textarea, select, button, a[href], [tabindex]';
const INNER_CONTROL = 'input:not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), [tabindex]:not([tabindex="-1"])';

/**
 * Ставит фокус в ячейку таблицы. Ячейка — это либо само поле (`IntInput`, `MoneyInput`), либо
 * обёртка с `data-nav-*`: antd `Select` не пробрасывает `data-*` на свой `<input>`, а только на
 * корневой `div`, поэтому фокус уходит на первое доступное поле внутри. В обычном текстовом поле
 * текст выделяется целиком — следующий ввод заменяет прежнее значение, как в таблицах.
 * Возвращает `false`, если фокус поставить некуда (ячейки нет или она отключена).
 */
export function focusNavCell(cell: HTMLElement | null | undefined): boolean {
  if (!cell) return false;
  const target = cell.matches(CONTROL) ? cell : cell.querySelector<HTMLElement>(INNER_CONTROL);
  if (!target || target.matches(':disabled')) return false;
  target.focus();
  if (target instanceof HTMLInputElement && target.getAttribute('role') !== 'combobox') target.select();
  return document.activeElement === target;
}

export function focusFirstNavCellOfRow(container: HTMLElement, rowIndex: number): void {
  focusNavCell(container.querySelector<HTMLElement>(`[data-nav-row="${rowIndex}"]`));
}
